/* Legacy Ranch Supply — ROI Calculator
 * Runs on any page that contains a #lrs-roi-calc element.
 * Idempotent: safe to load alongside any inline copy in product descriptions.
 */
(function () {
  'use strict';

  var COST = 1500;
  var WEAR_PER_MILE = 0.15;

  function g(id) { return document.getElementById(id); }
  function n(id) {
    var el = g(id);
    if (!el) return 0;
    var v = parseFloat(el.value);
    return isNaN(v) ? 0 : v;
  }
  function fmt(x) { return '$' + Math.round(x).toLocaleString(); }
  function fmtInt(x) { return Math.round(x).toLocaleString(); }
  function setText(id, txt) { var el = g(id); if (el) el.textContent = txt; }

  function calc() {
    if (!g('lrs-roi-calc')) return;
    var tanks = n('lrs-tanks');
    var trips = n('lrs-trips');
    var miles = n('lrs-miles');
    var minutes = n('lrs-minutes');
    var hourly = n('lrs-hourly');
    var fuel = n('lrs-fuel');
    var mpg = n('lrs-mpg');

    var annualTrips = tanks * trips * 52;
    var hoursSaved = annualTrips * (minutes / 60);
    var milesSaved = annualTrips * miles;
    var labor = hoursSaved * hourly;
    var fuelSaved = mpg > 0 ? (milesSaved / mpg) * fuel : 0;
    var wear = milesSaved * WEAR_PER_MILE;
    var total = labor + fuelSaved + wear;
    var paybackMonths = total > 0 ? Math.max(1, Math.round(COST / (total / 12))) : 0;
    var yearOneNet = total - COST;

    setText('lrs-total', fmt(total));
    setText('lrs-labor', fmt(labor));
    setText('lrs-fuel-out', fmt(fuelSaved));
    setText('lrs-wear', fmt(wear));
    setText('lrs-hours', fmtInt(hoursSaved));
    setText('lrs-miles-out', fmtInt(milesSaved));
    setText('lrs-payback', paybackMonths + ' months');
    setText('lrs-net', fmt(yearOneNet));
  }

  // Expose globally so any inline oninput handlers still work.
  window.lrsRoi = calc;

  function bindAndRun() {
    var el = g('lrs-roi-calc');
    if (!el) return;
    if (el.dataset.lrsWired === '1') { calc(); return; }
    el.dataset.lrsWired = '1';
    var inputs = el.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', calc);
    }
    calc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAndRun);
  } else {
    bindAndRun();
  }

  // Handle Shopify soft-navigations (page-transition) where DOMContentLoaded won't fire.
  document.addEventListener('shopify:section:load', bindAndRun);
  window.addEventListener('pageshow', bindAndRun);
})();
